<template>
    <article :class="bodyClass">
        <aside v-if="showAside" class="page-split__aside" :class="spacingClass">
            <slot name="aside"></slot>
        </aside>

        <main class="page-split__main" :class="spacingClass">
            <slot name="main"></slot>
        </main>
    </article>
</template>

<script>
    export default {
        props: {
            isCenter: { type: Boolean, default: false },
            hasColumns: { type: Boolean, default: false },
            spacing: { type: String, default: 'small' },
            reverse: { type: Boolean, default: false },
            showAside: { type: Boolean, default: true },
        },

        computed: {
            bodyClass() {
                return {
                    'page-split': true,
                    'page-split--reverse': this.reverse,
                }
            },
            spacingClass() {
                return {
                    [`page-split__spacing--${this.spacing}`]: true,
                }
            },
        },
    }
</script>
